/** Format similar to legacy SPM keys (e.g. 02822109199-002). */
export function generateParkingLegacyApiKey(): string {
  const digits = Array.from({ length: 11 }, () =>
    Math.floor(Math.random() * 10),
  ).join('');
  const suffix = String(Math.floor(Math.random() * 1000)).padStart(3, '0');
  return `${digits}-${suffix}`;
}
